import React,{ Component } from "react";
import PropTypes from 'prop-types';
//material-ui design helpers


//material-ui core components
import { Typography } from "@mui/material";

const s:any = {
  gridCellText: {
    padding: 4,
  },
};

class GridCellText extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  render(){
    const {text,classes} = this.props;
    return(
      <Typography sx={{...s.gridCellText}}>{text}</Typography>
    )
  }
}

GridCellText.propTypes = {
  style: PropTypes.object.isRequired,
  text: PropTypes.node
}

//GridCellText = withStyles(styles, { withTheme: true })(GridCellText);
export default GridCellText;